/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Input,
  Dropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
  Form,
  CardHeader,
  Spinner,
  Modal,
} from "reactstrap";
import format from "date-fns/";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";

import "chartist/dist/scss/chartist.scss";
import AddEditCallCenter from "./addEditPromos.js";
import "react-datepicker/dist/react-datepicker.css";

//i18n
import { withTranslation } from "react-i18next";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@material-ui/core";
import axios from "axios/axios.js";
import { MDBDataTable } from "mdbreact";
import moment from "moment";

const CallCenter = () => {
  const [selectedUsedBy, setSelectedUsedBy] = useState([]);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const exportCSV = () => {
    setLoadingSubmit(true);
    axios({
      url: "qrcode/exportQrCodes", // Replace with your backend URL
      method: "GET",
      responseType: "blob", // Specify the response type as blob
      headers: {
        Authorization: sessionStorage.getItem("token"),
      },
    })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Codes.xlsx");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setLoadingSubmit(false);
      })
      .catch((error) => {
        console.error("Error downloading the Excel file:", error);
      });
  };
  const columns = [
    // {
    // 	label: "ID",
    // 	field: "_id",
    // 	sort: "asc",
    // },
    {
      label: "Promo Code",
      field: "code",
      sort: "asc",
    },
    {
      label: "Percentage ",
      field: "Value",
      sort: "asc",
    },
    {
      label: "End At",
      field: "endAt",
      sort: "asc",
    },
    {
      label: "Actions",
      field: "actions",
    },
  ];
  const callCenterInitial = {
    name: "",
    email: "",
    phone: "",
    password: "",
  };
  const [modal, setModal] = useState(false);
  const [menu, setMenu] = useState(false);
  const [reload, setReload] = useState(false);
  const [callCenters, setCallCenters] = useState([]);
  const [callCenter, setCallCenter] = useState(callCenterInitial);
  const [selectedCallCenter, setSelectedCallCenter] = useState();
  const [edit, setEdit] = useState(false);

  const handleCloseModal = () => setModal((prev) => !prev);

  useEffect(() => {
    axios
      .get("promocodes/all", {
        headers: {
          Authorization: sessionStorage.getItem("token"),
        },
      })
      .then((res) => {
        setCallCenters(res.data);
      })
      .catch((e) => {});
  }, [reload]);

  const handleDelete = (id) => {
    let confirm = window.confirm(
      "You are about to delete this image, do you wish to continue?"
    );
    if (confirm) {
      axios
        .delete(`promocodes/delete/${id}`, {
          headers: {
            Authorization: sessionStorage.getItem("token"),
          },
        })
        .then((res) => {
          setCallCenter(callCenterInitial);
          setSelectedCallCenter(null);
          setReload(!reload);
        })
        .catch((e) => {});
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={8}>
                <h5 className="page-title">Promo Code</h5>
              </Col>
            </Row>
          </div>

          <Row className="mb-4">
            <Col>
              <Accordion expanded={menu} style={{ boxShadow: "none" }}>
                <AccordionSummary
                  style={{ backgroundColor: "#E9ECEF" }}
                  onClick={() => {
                    setMenu(!menu);
                  }}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <h6
                    style={{
                      fontWeight: "bold",
                      color: "#5B626B",
                    }}
                  >
                    {!selectedCallCenter ? "Add" : "Edit"} Promo Code
                  </h6>
                </AccordionSummary>
                <AccordionDetails>
                  <AddEditCallCenter
                    callCenter={callCenter}
                    selectedCallCenter={selectedCallCenter}
                    setCallCenter={setCallCenter}
                    setSelectedCallCenter={setSelectedCallCenter}
                    setReload={setReload}
                  />
                </AccordionDetails>
              </Accordion>
            </Col>
          </Row>

          <Row>
            <Col>
              <Card>
                <CardHeader>
                  <h6 style={{ fontWeight: "bold" }}>Promo Codes List</h6>
                </CardHeader>
                <CardBody>
                  {/* <div className="col-12">
                    <button
                      className="btn btn-primary"
                      style={{ marginBottom: "3vh" }}
                      type={loadingSubmit ? null : "Export"}
                      onClick={exportCSV}
                    >
                      {loadingSubmit ? (
                        <Spinner size={"sm"} color="secondary" />
                      ) : (
                        <>Export</>
                      )}
                    </button>
                  </div> */}
                  <MDBDataTable
                    hover
                    responsive
                    noBottomColumns
                    data={{
                      columns: columns,
                      rows: callCenters?.map((one, index) => {
                        return {
                          ...one,
                          endAt: moment.utc(one.endAt).format("DD-MM-YYYY"),
                          Value: one.value + "%",
                          actions: (
                            <Row>
                              <Col md={3} xs={3}>
                                <Link
                                  to="#"
                                  className="btn btn-info btn-sm"
                                  style={{
                                    marginLeft: "0.2vw",
                                  }}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setSelectedUsedBy(one.usedBy);
                                    setModal(true);
                                  }}
                                >
                                  <i className="fas fa-info"></i>
                                </Link>
                              </Col>
                              <Col md={3} xs={3}>
                                <Link
                                  to="#"
                                  className="btn btn-danger btn-sm"
                                  style={{
                                    marginLeft: "0.2vw",
                                  }}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleDelete(one._id);
                                  }}
                                >
                                  <i className="fas fa-trash"></i>
                                </Link>
                              </Col>
                            </Row>
                          ),
                        };
                      }),
                    }}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        {/* ========= Modal ========= */}
        <Modal
          isOpen={modal}
          toggle={handleCloseModal}
          className="my-modal"
          centered
          size="xl"
        >
          {selectedUsedBy && (
            <div className="py-3 px-5">
              <h3 className="text-center mb-4">Used By</h3>
              <Row className="fs-5 fw-bold mb-3">
                <Col sm={1}>#</Col>
                <Col sm={4}>Name</Col>
                <Col sm={7}>Email</Col>
              </Row>
              {selectedUsedBy?.map((ub, ind) => (
                <>
                  <Row key={ub._id} className="mb-3">
                    <Col sm={1}>{ind + 1}</Col>
                    <Col sm={4}>{ub.firstName + " " + ub.lastName}</Col>
                    <Col sm={7}>{ub.email}</Col>
                  </Row>
                </>
              ))}
            </div>
          )}
        </Modal>
      </div>
    </React.Fragment>
  );
};

CallCenter.propTypes = {
  t: PropTypes.any,
};

export default withTranslation()(CallCenter);
